var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoofBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2728.592,
    height: 989.069,
    viewBox: "0 0 2728.592 989.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(19.546 -4564.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M487.84,668.437v-204.1h-154V754.376L98.928,885.471V1043.39L1588.3,216.395V54.321Z",
    transform: "translate(-118.473 4509.984)",
    fill: "#25b6ee",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M1508.992,644.706V802.625L269.772,216.395V54.321Z",
    transform: "translate(1200.054 4509.984)",
    fill: "#25b6ee",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M1240.391,503.008,296.645,56.523,284.673,81.906l159.395,75.41L436.693,171.6l25.283,12.133,7.446-14.424L1057.66,447.6l-7.252,16.354,25.319,12.088,7.292-16.445,145.4,68.788Z",
    transform: "translate(1311.257 4527.018)",
    fill: "#25b6ee",
    opacity: 0.05
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofBackground);
export default __webpack_public_path__ + "static/media/RoofBackground.49e008554a9446f0c9599967fda12219.svg";
export { ForwardRef as ReactComponent };